import Card, { CardBody, CardHeader, CardTitle } from "../../../../bootstrap/Card"
import Button from "../../../../bootstrap/Button"
import Checks from "../../../../bootstrap/forms/Checks"
import Money from "../../../../../helpers/utils/money/money"

const ProductsConfigStep = ({ 
    categoriesWithProducts, 
    selectedProducts, 
    onProductToggle, 
    onSelectAll, 
    onClear 
}) => {
    return (
        <Card>
            <CardHeader>
                <CardTitle>Configuração de Produtos</CardTitle>
            </CardHeader>
            <CardBody>
                <div className="d-flex gap-2 mb-4">
                    <Button color="dark" size="sm" isLight onClick={onSelectAll}>
                        Selecionar Todos
                    </Button>
                    <Button color="dark" size="sm" isLight onClick={onClear}>
                        Limpar
                    </Button>
                </div>
                {categoriesWithProducts.map(cat => (
                    <div key={cat.app_category_id} className="mb-4">
                        <h5>
                            {cat.category_name} 
                            <small className="text-muted"> ({cat.products.length} produtos)</small>
                        </h5>
                        <div className="row">
                            {cat.products.map(p => {
                                const isSelected = selectedProducts.some(sp => sp.app_item_id === p.id)
                                return (
                                    <div key={p.id} className="col-md-6 mb-3">
                                        <Card 
                                            className={isSelected ? 'border-dark bg-light' : ''} 
                                            onClick={() => onProductToggle(p)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <CardBody className="p-3">
                                                <div className="d-flex align-items-center">
                                                    {p.image_url && (
                                                        <img 
                                                            src={p.image_url} 
                                                            alt={p.name} 
                                                            style={{ width: 60, height: 60, objectFit: 'cover' }} 
                                                            className="me-3 rounded" 
                                                        />
                                                    )}
                                                    <div className="flex-grow-1">
                                                        <Checks 
                                                            type="checkbox" 
                                                            checked={isSelected} 
                                                            readOnly 
                                                            className="me-2" 
                                                        />
                                                        <strong>{p.name}</strong>
                                                        <div className="text-muted small">
                                                            {Money.centsToMaskMoney(p.price || 0)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ))}
            </CardBody>
        </Card>
    )
}

export default ProductsConfigStep
